import React from 'react';
import { OwnerLetter } from './OwnerLetter';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { useQuery } from '@apollo/client';
import { getMissingItemsByOwner } from '../api';

interface Props {
  owner: any;
}

export const PdfButton = (props: Props) => {
  const { data, loading, error } = useQuery(getMissingItemsByOwner, {
    variables: {
      status: 'Missing',
      owner: String(props.owner.PhysicalOwner),
    },
  });
  const getFullDate = () => {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    let today = new Date();
    let month = monthNames[today.getMonth()];
    let dayOfMonth = today.getDate();
    let year = today.getFullYear();
    return `${month} ${dayOfMonth}, ${year}`;
  };

  if (loading) return <div>Generating PDF...</div>;
  if (error) return <div>{JSON.stringify(error)}</div>;

  return (
    <PDFDownloadLink
      document={
        <OwnerLetter
          propertyCoordinator={props.owner.PropertyCoordinator}
          date={getFullDate()}
          inventoryYear={new Date().getFullYear()}
          departmentName={props.owner.DepartmentName}
          businessUnit={props.owner.PhysicalOwner}
          missingItems={data.assetsByOwner}
          mailStop={props.owner.mailStop}
        />
      }
      fileName='ownerLetter.pdf'>
      {({ blob, url, loading, error }) => {
        if (error) {
          return null;
        }
        if (loading) return <div>Generating PDF...</div>;
        return 'Download Owner Letter';
      }}
    </PDFDownloadLink>
  );
};
